/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Logo as CanyouLogo } from '../../../components/Logo';

export const Logo: React.FC = () => <CanyouLogo />;
